/**
 * @description Helper function to return date ranges as milliseconds from days back.
 * Returns dates at midnight in the local timezone as millisecond timestamps
 * Note: These timestamps represent midnight in the local timezone, which the backend
 * interprets using the clientTimeZone parameter
 */
export const getDateRangesInMsFromDaysBack = (daysBack: number): { startDateMs: number; endDateMs: number } => {
  const now = new Date();

  // Calculate start date (N days back at local midnight)
  const startDate = new Date(now);
  startDate.setDate(startDate.getDate() - daysBack);
  startDate.setHours(0, 0, 0, 0);
  const startDateMs = startDate.getTime();

  // Calculate end date (today at end of day - 23:59:59.999)
  const endDate = new Date(now);
  endDate.setHours(23, 59, 59, 999);
  const endDateMs = endDate.getTime();

  return {
    startDateMs,
    endDateMs,
  };
};
